// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1__c6e7619aa56dcbddd785","cls2":"ConfirmationModal-cls2__e77d65211028190eeea7 ConfirmationModal-cls1__c6e7619aa56dcbddd785"};